import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sidebar-autocomplete',
  templateUrl: './sidebar-autocomplete.component.html',
  styleUrls: ['./sidebar-autocomplete.component.scss'],
})
export class SidebarAutocompleteComponent implements OnInit {
  @Input() controlName!: string;
  @Input() form!: FormGroup;
  @Input() isRequired: boolean = false;
  @Input() label: string = '';

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    if (this.isRequired)
      this.form.addControl(
        this.controlName,
        this.formBuilder.control('', Validators.required)
      );
    else this.form.addControl(this.controlName, this.formBuilder.control(''));
  }
}
